<section class="mapping-shell">
  <header class="mapping-header">
    <div class="title">マッピング（Rete.js）</div>
    <div class="filters">
      <label>
        Entity 絞り込み
        <input type="text" [formControl]="filterForm.controls.entity" placeholder="fieldName / 表示名" />
      </label>
      <label>
        View 絞り込み
        <input type="text" [formControl]="filterForm.controls.view" placeholder="fieldName" />
      </label>
    </div>
    <div class="hint">線で接続すると、対象の View field の formula が自動で更新されます。</div>
  </header>

  <div class="editor-wrap">
    <div #container class="editor"></div>
  </div>
</section>

